<template>
  <div class="parking-appeal-page">
    <div class="nav-header">
      <i class="el-icon-arrow-left" @click="$router.back()"></i>
      <span class="title">停车费申诉审核</span>
      <div class="placeholder"></div>
    </div>

    <div class="content-body">
      <div class="empty-state" v-if="appealList.length === 0">
        <i class="el-icon-folder-opened" style="font-size: 80px; color: #ccc;"></i>
        <p>暂无申诉记录</p>
      </div>

      <div class="appeal-list" v-else>
        <div class="appeal-card" v-for="(item, index) in appealList" :key="index">
          <div class="card-header">
            <span class="plate">{{ item.plateNo || '-' }}</span>
            <span class="status" :class="getStatusClass(item.status)">{{ getStatusText(item.status) }}</span>
          </div>
          <div class="card-body">
            <div class="info-row">
              <span class="label">订单编号</span>
              <span class="value">{{ item.orderNo || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="label">申诉原因</span>
              <span class="value">{{ item.reason || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="label">提交时间</span>
              <span class="value">{{ item.createTime || '-' }}</span>
            </div>
          </div>
          <div class="card-footer" v-if="item.status === 0">
            <el-button size="small" type="primary" @click="handleApprove(item)">通过</el-button>
            <el-button size="small" @click="handleReject(item)">拒绝</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParkingAppeal',
  data() {
    return {
      appealList: []
    };
  },
  mounted() {
    this.getAppealList();
  },
  methods: {
    getAppealList() {
      // TODO: 调用接口获取申诉列表
      console.log('获取申诉列表');
    },
    getStatusText(status) {
      const map = { 0: '待审核', 1: '已通过', 2: '已拒绝' };
      return map[status] || '未知';
    },
    getStatusClass(status) {
      const map = { 0: 'pending', 1: 'approved', 2: 'rejected' };
      return map[status] || '';
    },
    handleApprove(item) {
      console.log('通过', item);
    },
    handleReject(item) {
      console.log('拒绝', item);
    }
  }
};
</script>

<style lang="scss" scoped>
.parking-appeal-page {
  background-color: #F7F9FC;
  min-height: 100vh;
}

.nav-header {
  background: #FFF;
  padding: 15px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title { font-size: 18px; font-weight: bold; }
  i { font-size: 20px; }
  .placeholder { width: 20px; }
}

.content-body {
  padding: 16px;
}

.empty-state {
  text-align: center;
  padding-top: 80px;
  img { width: 120px; margin-bottom: 16px; }
  p { color: #999; font-size: 14px; }
}

.appeal-list {
  .appeal-card {
    background: #FFF;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 12px;
    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      .plate { font-size: 16px; font-weight: bold; }
      .status {
        font-size: 12px;
        padding: 4px 8px;
        border-radius: 4px;
        &.pending { background: #FFF7E6; color: #FF9500; }
        &.approved { background: #F6FFED; color: #52C41A; }
        &.rejected { background: #FFF1F0; color: #FF4D4F; }
      }
    }
    .card-body {
      .info-row {
        display: flex;
        justify-content: space-between;
        padding: 6px 0;
        font-size: 13px;
        .label { color: #999; }
        .value { color: #333; }
      }
    }
    .card-footer {
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid #F0F0F0;
      display: flex;
      gap: 12px;
      justify-content: flex-end;
    }
  }
}
</style>